import React, { useEffect, useState } from 'react';
import './team-view.styles.scss';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import PlayerNameIcon from '@/components/PLAYER/player-blocks/components/status-elements/player-name-icon.component';
import { sortPlayers } from '@/utils/sortPlayers';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { completePlayerData } from '@/components/PREVIEW/previewPlayers';
import TeamViewContent from './team-view-content.component';

const TeamView = ({
  gameData,
  playerList,
  teamList,
  isManager
}) => {

  const { teamPath } = useParams();
  const [teamData, setTeamData] = useState(null);
  const [ teamMemberList, setTeamMemberList ] = useState([]);
  const [ totalTeamPlayerPoints, setTotalTeamPlayerPoints ] = useState(0);
  const [ teamEarnedPoints, setTeamEarnedPoints ] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  let teamListener;

  useEffect(() => {

    return () => {
      if (teamListener) teamListener();
    }
  }, [])

  useEffect(() => {
    if (!teamPath || !gameData || !teamList) return;
    console.log(teamPath);
    getTeamData();
  }, [teamPath, gameData, teamList])

  

  function getTeamData() {
    if (location.pathname.includes('/preview/manager/')) {
      const teamInfo = Object.values(completePlayerData)
        .find(p => p.path === teamPath);
      setTeamData(teamInfo);
      return;
    }
    setTeamData(Object.values(teamList).find(t => t.path === teamPath));
  }

  return (
    <div className='team-view-container'>
      {
        teamData &&
        <TeamViewContent
          gameData={gameData}
          teamData={teamData}
          playerList={playerList}
          isManager={isManager} />
      }
    </div>
  )
}

export default TeamView